import React from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";
import { RootState } from "../../../reducers/store";
import Tooltip from "../../vapor/tooltip";
import { FormattedMessage } from "react-intl";

export interface TitleProps {
    content: string | React.ReactNode;
    showCredits: boolean;
}

const Title = (props: TitleProps) => {
    const userPackage = useSelector((state: RootState) => state.userPackage);
    const modebisconfig = useSelector(
        (state: RootState) => state.modebisconfig,
    );
    const hasExtra = userPackage?.negative_credits;
    /*const zeroCredits =
    (userPackage?.credits?.limit === 0 || (userPackage?.credits?.limit && userPackage?.credits?.limit < 0));*/
    const noCredits =
        !hasExtra &&
        (userPackage?.credits === 0 ||
            (userPackage?.credits && userPackage?.credits < 0));

    return (
        <div
            className={
                "bis-title" +
                (modebisconfig?.trial && modebisconfig?.readOnly
                    ? " noCredits"
                    : "")
            }
        >
            <div>{props.content}</div>
            {props.showCredits &&
            (!modebisconfig?.trial ||
                (modebisconfig?.trial && !modebisconfig?.readOnly)) ? (
                <div className="bis-credits-widget vapor-title">
                    <div
                        className={`bis-credits-widget-amount${noCredits ? " noCredits" : ""}`}
                    >
                        {userPackage.credits ? userPackage.credits : "-"}
                    </div>
                    <div className="bis-credits-widget-divider">&nbsp;</div>
                    <div className="bis-credits-widget-label">
                        <FormattedMessage id="widgets.credits.title" />
                        {noCredits && !hasExtra && (
                            <Tooltip
                                width={320}
                                direction="left"
                                content={
                                    <div className="noCreditTooltip">
                                        <div
                                            style={{
                                                marginBottom: "10px",
                                                fontWeight: 500,
                                            }}
                                        >
                                            <FormattedMessage id="widgets.credits.negativeTooltipTitle" />
                                        </div>
                                        <div>
                                            <FormattedMessage id="widgets.credits.negativeTooltipDescription" />
                                        </div>
                                    </div>
                                }
                            >
                                <span
                                    style={{
                                        marginLeft: "8px",
                                        color: "var(--status-warning)",
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={["far", "exclamation-triangle"]}
                                    />
                                </span>
                            </Tooltip>
                        )}
                    </div>
                    {hasExtra && (
                        <div className="bis-credits-widget-label-extra">
                            <FormattedMessage id="widgets.credits.extra" />
                            <Tooltip
                                width={320}
                                direction="left"
                                content={
                                    <div className="noCreditTooltip">
                                        <div
                                            style={{
                                                marginBottom: "10px",
                                                fontWeight: 500,
                                            }}
                                        >
                                            <FormattedMessage id="widgets.credits.extraTooltipTitle" />
                                        </div>
                                        <div>
                                            <FormattedMessage id="widgets.credits.extraTooltipDescription" />
                                        </div>
                                    </div>
                                }
                            >
                                <span style={{ marginLeft: "8px" }}>
                                    <FontAwesomeIcon
                                        icon={["fas", "circle-info"]}
                                    />
                                </span>
                            </Tooltip>
                        </div>
                    )}
                </div>
            ) : null}
        </div>
    );
};

export default Title;
